import styles from "./index.module.scss";
import Icon from "/components/common/icon";

export default function BaltexReviews({ items }) {
  return (
    <div className={styles.News}>
      {items.map((review) => (
        <div key={review.NAME}>
          <span>{review.NAME}</span>
          <div className={styles.Text}>
            <div className={styles.TextLeft}>
              <div className={styles.TextRating}>
                <Icon id="star" width={22} height={22} fill={"#ADAEB1"} />
                <Icon id="star" width={22} height={22} fill={"#ADAEB1"} />
                <Icon id="star" width={22} height={22} fill={"#ADAEB1"} />
                <Icon id="star" width={22} height={22} fill={"#ADAEB1"} />
                <Icon id="star" width={22} height={22} fill={"#ADAEB1"} />
              </div>
              <div className={styles.TextDate}>08.11.2024</div>
            </div>
            <div className={styles.TextRight}>{review.PREVIEW_TEXT}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
